import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-[480px] lg:min-h-[520px] bg-[#e6f7f5] overflow-hidden">
      <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row lg:items-center">
        {/* Left text */}
        <div className="flex-1 flex items-center justify-center lg:justify-start px-4 md:px-6 lg:px-10 py-6 md:py-8 lg:py-12 order-2 lg:order-1">
          <div className="max-w-xl mx-auto lg:mx-0 w-full">
            <div className="inline-flex items-center gap-2 bg-brand-accent/10 text-brand-accent text-xs md:text-sm font-semibold px-4 py-2 rounded-full mb-5 border border-brand-accent/20">
              <i className="ri-flashlight-fill text-brand-accent"></i>
              Réparateur de fenêtres — Paris 15ᵉ · 75015
            </div>
            <h1 id="hero-title" className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] font-bold text-brand-dark mb-4 leading-tight font-heading">
              Réparation de fenêtres, volets & baies vitrées
              <br />
              <span className="text-brand-accent">à Paris 15ᵉ</span>
            </h1>
            <p className="text-sm md:text-lg text-brand-text/60 mb-3 max-w-md">
              Votre fenêtre ferme mal, votre volet est bloqué ou votre baie vitrée déraille ?
            </p>
            <p className="text-sm md:text-base text-brand-accent mb-8 max-w-md font-medium">
              <i className="ri-map-pin-2-fill mr-1"></i>
              Intervention 24/48h · Devis gratuit · Société assurée
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/devis-fenetre-paris-15/"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-brand-accent hover:opacity-90 text-white font-bold text-sm md:text-base px-8 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-brand-accent/20"
              >
                Devis gratuit
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="tel:+33187668155"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white hover:bg-white/80 text-brand-dark font-bold text-sm md:text-base px-8 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer border border-brand-accent/30"
              >
                <i className="ri-phone-fill text-brand-accent"></i>
                01 87 66 81 55
              </a>
            </div>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-2 md:gap-5 text-xs md:text-sm text-brand-text/60">
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-yellow-400"></i>
                4.9/5 · 10+ ans · Devis gratuit · Techniciens salariés
              </span>
            </div>
          </div>
        </div>

        {/* Right image */}
        <div className="w-full lg:w-[46%] xl:w-[44%] h-72 sm:h-80 md:h-96 lg:h-[520px] lg:max-h-[520px] relative order-1 lg:order-2 lg:self-center flex-shrink-0">
          <img
            alt="Technicien DF PRO réparant une fenêtre à Paris 15 — réparation menuiseries"
            className="w-full h-full object-cover object-top"
            loading="eager"
            src="/images/dfpro-hero-v2.webp"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#e6f7f5]/60 via-[#e6f7f5]/15 to-transparent lg:bg-gradient-to-l lg:from-transparent lg:via-transparent lg:to-[#e6f7f5]"></div>
          {/* Floating badge */}
          <div className="absolute top-4 right-3 sm:right-4 lg:top-6 lg:right-6 z-10">
            <div className="bg-yellow-400 text-brand-dark font-extrabold text-[10px] sm:text-xs md:text-sm lg:text-base px-3 py-2 sm:px-4 sm:py-2.5 md:px-6 md:py-3.5 rounded-2xl shadow-2xl shadow-yellow-400/40 animate-pulse cursor-default flex items-center gap-1.5 sm:gap-2 md:gap-2.5 border-2 border-yellow-300">
              <div className="w-6 h-6 sm:w-7 sm:h-7 md:w-9 md:h-9 flex items-center justify-center bg-brand-dark rounded-full flex-shrink-0">
                <i className="ri-price-tag-3-fill text-yellow-400 text-xs sm:text-sm md:text-lg"></i>
              </div>
              <span className="whitespace-nowrap tracking-tight">100% DEVIS GRATUIT</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}